import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveAuth, clearAuth, loadUser } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(loadUser());
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    const t = localStorage.getItem("fn_token");
    if (!t) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("fn_user", JSON.stringify(data));
    } catch { clearAuth(); setUser(null); }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveAuth(data.token, data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const signup = async (body) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", body);
      saveAuth(data.token, data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => { clearAuth(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
